module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/superAdmin/superAdmin.component.css
// module id = ./src/app/superAdmin/superAdmin.component.css
// module chunks = main